import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validador para permitir apenas links de redes sociais autorizadas
 * Domínios permitidos: YouTube, LinkedIn, Facebook, Instagram, X (Twitter) e TikTok
 * @returns ValidatorFn que retorna null se válido ou {invalidSocialMedia: true} se inválido
 */
export function allowedSocialMediaValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null; // Não valida se estiver vazio
    }

    const url = control.value.toLowerCase();
    const allowedDomains = [
      'youtube.com',
      'youtu.be',
      'linkedin.com',
      'facebook.com',
      'fb.com',
      'instagram.com',
      'twitter.com',
      'x.com',
      'tiktok.com'
    ];

    const isAllowed = allowedDomains.some(domain => url.includes(domain));

    return isAllowed ? null : { invalidSocialMedia: true };
  };
}
